export default "__VITE_ASSET__a62ad315__"